import React from 'react';

import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';

export default function IconWithSmallerIcon({ iconeMaior, iconeMenor }) {
  const styledIconeMaior = React.cloneElement(iconeMaior, {
    style: { ...iconeMaior.props.style, fontSize: '36px' },
  });

  const styledIconeMenor = React.cloneElement(iconeMenor, {
    style: {
      fontSize: '10px',
      margin: '0',
      padding: '0',
      position: 'static',
      transform: 'none',
      display: 'block',
      lineHeight: '1',
      verticalAlign: 'middle',
      ...iconeMenor.props.style,
      zIndex: 2,
    },
  });

  return (
    <span style={{ display: 'inline-block' }}>
      <Box
        position="relative"
        display="inline-block"
        width={36}
        height={36}
        style={{ verticalAlign: 'middle' }}
      >
        {styledIconeMaior}
        <Box
          style={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            width: 14,
            height: 14,
            backgroundColor: 'white',
            borderRadius: '50%',
            zIndex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
          }}
        >
          {styledIconeMenor}
        </Box>
      </Box>
    </span>
  );
}

IconWithSmallerIcon.propTypes = {
  iconeMaior: PropTypes.element.isRequired,
  iconeMenor: PropTypes.element.isRequired,
};
